import { render, staticRenderFns } from "./RoleDrawer.vue?vue&type=template&id=77f52b04&scoped=true"
import script from "./RoleDrawer.vue?vue&type=script&lang=js"
export * from "./RoleDrawer.vue?vue&type=script&lang=js"
import style0 from "./RoleDrawer.vue?vue&type=style&index=0&id=77f52b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f52b04",
  null
  
)

export default component.exports